<template>
    <div class="m-3" v-if="!isNew">
        <lecturers-grid
            ref="lecturersGrid"
            :relatedEventId="Number(entryId)"
            :showHideButton="false"
            :showPinButton="false"
            :showNewButton="false"
            :showResizeIcon="false"
            :showSettingsBtn="false"
            showCertificatesBtn
            :showBtns="isLockedForEdit ? false :true"
            @onEdit="onEdit"
            @syncLecturerWithMoodle="syncLecturerWithMoodle"
        ></lecturers-grid>
    </div>
</template>

<script>
    import LecturersGrid from '../../components/lecturers/LecturersGrid';
    import { mapGetters } from 'vuex';

    export default {
        name: 'lecturers-management',
        components: {
            LecturersGrid
        },
        props: {
            registerId: {
                type: [Number, String],
                required: true
            },
            entryId: {
                type: [Number, String]
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {};
        },
        methods: {
            refreshLecturersGrid() {
                const grid = this.$refs.lecturersGrid;
                if (grid) {
                    grid.refresh();
                }
            },
            syncLecturerWithMoodle(id) {
                this.refreshLecturersGrid();
            },
            onEdit() {
                this.$emit('onEdit');
            }
        },
        computed: {
            isNew() {
                return this.entryId === undefined;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            hasEditRights() {
                return true;
            },
            ...mapGetters(['claims'])
        }
    };
</script>


<style>
</style>
